import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import TaskModal from './TaskModal';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import axios from 'axios';
import TaskGrid from './TaskGrid';
import { ConvertArrayToXML, getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions, getUserPermissions, hasPermission } from '../../utils/permissionHelper';
import { logAuditEvent } from '../../utils/auditLogger';

function TaskMain(props) {
  const [getTaskList, setTaskList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Task';

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchTask();
  }, []);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Task');
  }, [moduleName]);

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add task modal');
  }
  function closeModal() {
    setIsOpen(false);
  }

  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const taskModel = data;
      logAuditEvent(moduleName, 'Save Task Attempt', taskModel.TaskId ? `TaskId=${taskModel.TaskId}` : 'Creating new task');
      const selectedCompanies = Array.isArray(taskModel.SelectedCompanies)
        ? taskModel.SelectedCompanies
        : [];
      const hasClient = !!taskModel.ClientId;
      const hasCompanyType = !!taskModel.ClientCompanyTypeId;
      const hasSelectedCompanies = selectedCompanies.length > 0;
      if (hasClient && hasCompanyType && hasSelectedCompanies) {
        const hasMissingReference = selectedCompanies.some((item) => {
          const referenceValue = item.Referance ?? item.ReferenceNumber;
          return !referenceValue || String(referenceValue).trim().length === 0;
        });
        if (hasMissingReference) {
          CreateAlert("Please enter reference number for all selected client companies!!", "Warning", setAlert);
          return;
        }
      }
      var lcolumnSC = [];
      if (taskModel.SelectedCompanies) {
        taskModel.SelectedCompanies.forEach(x => {
          let lcolumnSCt = {
            ClientCompanyId: x.ClientCompanyId,
            ReferenceNumber: x.Referance
          }
          lcolumnSC.push(lcolumnSCt);
        });
      }

      let taskDetails = {
        TaskId: null,
        TitleId: taskModel.TitleId,
        ClientId: taskModel.ClientId ? taskModel.ClientId : null,
        ClientInvestment: lcolumnSC.length > 0 ? ConvertArrayToXML(lcolumnSC, '<ClientInvestments>', '<ClientInvestment>') : null,
        AssignedToUserId: taskModel.AssignedToUserId,
        PriorityId: taskModel.PriorityId,
        StatusId: taskModel.StatusId,
        Description: taskModel.Description,
        UserId: getStorageValues('userId'),
      };
      if (validation(taskDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveTask",
            taskDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              logAuditEvent(moduleName, 'Task Saved', response.data.data[0].message || 'Success');
              fetchTask();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Error", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
          logAuditEvent(moduleName, 'Task Save Failed', error.message || 'Unknown error');
        }
      }
    }
  }
  function validation(taskDetails) {
    var validation = true;
    if (taskDetails) {
      if (taskDetails.TitleId !== null) {
        if (taskDetails.TitleId.length === 0) {
          CreateAlert("Please select or create title!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please select or create title!!", "Warning", setAlert);
        validation = false;
      }

      if (taskDetails.AssignedToUserId !== null) {
        if (taskDetails.AssignedToUserId.length === 0) {
          CreateAlert("Please select assigned to user!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please enter title!!", "Warning", setAlert);
        validation = false;
      }
      if (taskDetails.PriorityId !== null) {
        if (taskDetails.PriorityId.length === 0) {
          CreateAlert("Please select priority!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please select priority!!", "Warning", setAlert);
        validation = false;
      }
      if (taskDetails.StatusId !== null) {
        if (taskDetails.StatusId.length === 0) {
          CreateAlert("Please select status!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please select status!!", "Warning", setAlert);
        validation = false;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const fetchTask = async () => {
    try {
      let taskDetails = {
        UserId: getStorageValues('userId'),
        ByUser: 1
      };
      const response = await axios.get(getApiBaseUrl() + "/tasklist", { params: taskDetails });
      if (response.status === 200) {
        setTaskList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleRefresh = () => {
    logAuditEvent(moduleName, 'Refresh Click', 'Refreshed task list');
    fetchTask();
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayText={""}
        displayModule={props.Module}
        onModelOpen={openAddModal}
        onRefresh={handleRefresh}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={true}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <TaskGrid TaskData={getTaskList} fetchTask={fetchTask} UserPermissions={getUserModulePermission}/>
      <TaskModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}
      />
    </>
  )
}

export default TaskMain